import { Link } from "react-router-dom";
import { ArrowUp } from "lucide-react";
import logoFooter from "@/assets/logo-footer.png";

const Footer = () => {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="relative border-t border-primary/80 bg-primary text-primary-foreground">
      <div className="container py-12">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div>
            <img src={logoFooter} alt="LegalCalculator.in — Indian legal calculators logo" className="w-[180px]" />
            <p className="mt-3 text-sm text-primary-foreground/70">
              Accurate legal calculators for Indian professionals. Stamp duty, court fees, interest & more.
            </p>
          </div>

           {/* Calculators */}
           <div>
             <p className="footer-heading mb-3 text-sm font-semibold uppercase tracking-wider">Calculators</p>
             <ul className="space-y-2 text-sm">
                <li><Link to="/employment-law-calculators" className="text-primary-foreground/70 hover:text-accent transition-colors">Employment Law</Link></li>
                <li><Link to="/property-law-calculators" className="text-primary-foreground/70 hover:text-accent transition-colors">Property Law</Link></li>
                <li><Link to="/financial-law-calculators" className="text-primary-foreground/70 hover:text-accent transition-colors">Financial Law</Link></li>
                <li><Link to="/family-law-calculators" className="text-primary-foreground/70 hover:text-accent transition-colors">Family Law</Link></li>
                <li><Link to="/injury-law-calculators" className="text-primary-foreground/70 hover:text-accent transition-colors">Injury Law</Link></li>
                <li><Link to="/consumer-law-calculators" className="text-primary-foreground/70 hover:text-accent transition-colors">Consumer Law</Link></li>
             </ul>
           </div>

           {/* Company */}
           <div>
             <p className="footer-heading mb-3 text-sm font-semibold uppercase tracking-wider">Company</p>
             <ul className="space-y-2 text-sm">
               <li><Link to="/about" className="text-primary-foreground/70 hover:text-accent transition-colors">About Us</Link></li>
               <li><Link to="/pricing" className="text-primary-foreground/70 hover:text-accent transition-colors">Pricing</Link></li>
               <li><Link to="/blog" className="text-primary-foreground/70 hover:text-accent transition-colors">Blog</Link></li>
               <li><Link to="/contact" className="text-primary-foreground/70 hover:text-accent transition-colors">Contact</Link></li>
             </ul>
           </div>

           {/* Legal */}
           <div>
             <p className="footer-heading mb-3 text-sm font-semibold uppercase tracking-wider">Legal</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy-policy" className="text-primary-foreground/70 hover:text-accent transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="text-primary-foreground/70 hover:text-accent transition-colors">Terms of Service</Link></li>
              <li><Link to="/disclaimer" className="text-primary-foreground/70 hover:text-accent transition-colors">Disclaimer</Link></li>
              <li><Link to="/refund-policy" className="text-primary-foreground/70 hover:text-accent transition-colors">Refund Policy</Link></li>
              <li><Link to="/shipping-and-delivery" className="text-primary-foreground/70 hover:text-accent transition-colors">Shipping & Delivery</Link></li>
              <li><Link to="/cookie-policy" className="text-primary-foreground/70 hover:text-accent transition-colors">Cookie Policy</Link></li>
              <li><Link to="/data-rights" className="text-primary-foreground/70 hover:text-accent transition-colors">Data Rights</Link></li>
              <li><Link to="/affiliate-disclosure" className="text-primary-foreground/70 hover:text-accent transition-colors">Affiliate Disclosure</Link></li>
            </ul>
          </div>
        </div>
      </div>

       {/* Bottom bar */}
       <div className="border-t border-primary-foreground/10">
         <div className="container flex flex-col items-center gap-2 py-4 text-center text-xs text-primary-foreground/70">
           <p>© {new Date().getFullYear()} LegalCalculator.in. All rights reserved.</p>
           <p>Disclaimer: Calculations are for reference purposes only and do not constitute legal advice.</p>
         </div>
       </div>

      {/* Back to top — mobile only */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-6 right-6 z-40 flex h-10 w-10 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-md transition-transform hover:scale-110 md:hidden"
        aria-label="Back to top"
      >
        <ArrowUp className="h-4 w-4" />
      </button>
    </footer>
  );
};

export default Footer;
